import {
    Accordion,
    AccordionItem,
    AccordionItemButton,
    AccordionItemHeading,
    AccordionItemPanel,
} from "react-accessible-accordion";
import Modal from "./Modal";
import Moment from "react-moment";
import PropTypes from "prop-types";
import React, { PureComponent } from "react";

export default class AvailableSessions extends PureComponent {
    static propTypes = {
        removeSession: PropTypes.func.isRequired,
        addSession: PropTypes.func.isRequired,
        presentations: PropTypes.object.isRequired,
        isLoading: PropTypes.bool.isRequired,
    };

    constructor(props) {
        super(props);

        this.state = {
            selectedPresentationId: null,
            showAddLinkedSessionsModal: false,
            showRemoveLinkedSessionsModal: false,
            showAddWaitlistModal: false,
            showNotifyMeModal: false,
            accordionExpanded: {},
        }
    }

    componentDidMount = () => {
        let accordionExpanded = {};
        this._flattenPresentations().forEach(presentation => {
            accordionExpanded[presentation.id] = "false";
        });
        this.setState({ accordionExpanded });
    };

    _getPresentation = id => {
        return this._flattenPresentations().find(p => p.id === parseInt(id));
    }

    _addSession = (id, e) => {
        e.stopPropagation();
        let presentation = this._getPresentation(id);
        if (presentation.presentationGroups.length > 0) {
            this.setState({ selectedPresentationId: parseInt(id), showAddLinkedSessionsModal: true });
        } else if (presentation.isFull && !presentation.hasWaitlist) {
            this.setState({ selectedPresentationId: parseInt(id), showNotifyMeModal: true });
        }
        else {
            this.props.addSession(id, e);
        }
    }

    _removeSession = (id, e) => {
        e.stopPropagation();

        let presentation = this._flattenPresentations().find(p => p.id === parseInt(id));
        if (presentation.presentationGroups.length > 0) {
            this.setState({ selectedPresentationId: parseInt(id), showRemoveLinkedSessionsModal: true });
        } else {
            this.props.removeSession(id, e);
        }
    }

    _flattenPresentations = () => {
        let groupedPresentations = this.props.presentations;
        return Object.keys(groupedPresentations).reduce(function (r, k) { return r.concat(groupedPresentations[k]); }, []);
    }

    _hideAddLinkedSessionsModal = () => {
        this.setState({ showAddLinkedSessionsModal: false });
    }

    _hideAddWaitlistModal = () => {
        this.setState({ showAddWaitlistModal: false });
    }

    _hideNotifyMeModal = () => {
        this.setState({ showNotifyMeModal: false });
    }

    _hideRemoveLinkedSessionsModal = () => {
        this.setState({ showRemoveLinkedSessionsModal: false });
    }

    _confirmAddLinkedSessions = (e) => {
        this.props.addSession(this.state.selectedPresentationId, e);
        this.setState({ selectedPresentationId: null, showAddLinkedSessionsModal: false });
    }

    _confirmAddWaitlist = (e) => {
        this.props.addSession(this.state.selectedPresentationId, e);
        this.setState({ selectedPresentationId: null, showAddWaitlistModal: false });
    }

    _confirmNotifyMe = (e) => {
        this.props.addSession(this.state.selectedPresentationId, e);
        this.setState({ selectedPresentationId: null, showNotifyMeModal: false });
    }

    _confirmRemoveLinkedSessions = (e) => {
        this.props.removeSession(this.state.selectedPresentationId, e);
        this.setState({ selectedPresentationId: null, showRemoveLinkedSessionsModal: false });
    }

    _getDotClass = specialty => {
        return "dot " + specialty.trim().replace(/[^a-z0-9]|\s+|\r?\n|\r/gmi, "-").toLowerCase();
    };

    _toggleDetails = id => {

        console.log("id: " + id);

        let { accordionExpanded } = this.state;
        let newAccordionExpanded = {};

        this._flattenPresentations().forEach(presentation => {
            if (presentation.id === id) {            
                newAccordionExpanded[presentation.id] = accordionExpanded[presentation.id] === "true" ? "false" : "true";    
                console.log("Set State: newAccordionExpanded: " + newAccordionExpanded[presentation.id]);            
            } else {
                newAccordionExpanded[presentation.id] = "false";                    
            }             
        });

        

        this.setState({ accordionExpanded: newAccordionExpanded });
    }

    _addWaitlistModal = () => {
        return (
            <Modal show={this.state.showAddWaitlistModal} onClose={this._hideAddWaitlistModal}>
                <h2 className="waitlist">Session Is Full</h2>
                <p>
                    Oh no!  The session you are interested in is full! <br />
                    Would you like to be placed on the waitlist for this session?
                </p>
                <div className="row mt-4">
                    <div className="col-6 pr-1"><button className="btn btn-primary btn-block" disabled={!this.state.selectedPresentationId} onClick={e => this._confirmAddWaitlist(e)}>Yes</button></div>
                    <div className="col-6 pl-1"><button className="btn btn-primary btn-block" disabled={!this.state.selectedPresentationId} onClick={this._hideAddWaitlistModal}>No</button></div>
                </div>

            </Modal>
        );
    }

    _notifyMeModal = () => {
        return (
            <Modal show={this.state.showNotifyMeModal} onClose={this._hideNotifyMeModal}>
                <h2 className="waitlist">Session Is Full</h2>
                <p>
                    Oh no! This session is full! <br />
                    Would you like to be notified if space becomes available?

                </p>
                <div className="row mt-4">
                    <div className="col-6 pr-1"><button className="btn btn-primary btn-block" disabled={!this.state.selectedPresentationId} onClick={e => this._confirmNotifyMe(e)}>Yes</button></div>
                    <div className="col-6 pl-1"><button className="btn btn-primary btn-block" disabled={!this.state.selectedPresentationId} onClick={this._hideNotifyMeModal}>No</button></div>
                </div>

            </Modal>
        );
    }

    _addLinkedPresentationsModal = () => {
        return (
            <Modal show={this.state.showAddLinkedSessionsModal} onClose={this._hideAddLinkedSessionsModal}>
                <h2 className="linked">Linked Sessions</h2>
                <p>The session you have selected is linked to other sessions in the conference. Adding this session will add all linked sessions.</p>
                <p>Would you like to add the selected session?</p>
                <div className="row mt-4">
                    <div className="col-6 pr-1"><button className="btn btn-primary btn-block" disabled={!this.state.selectedPresentationId} onClick={e => this._confirmAddLinkedSessions(e)}>Yes</button></div>
                    <div className="col-6 pl-1"><button className="btn btn-secondary btn-block" disabled={!this.state.selectedPresentationId} onClick={this._hideAddLinkedSessionsModal}>No</button></div>
                </div>

            </Modal>
        );
    }

    _removeLinkedPresentationsModal = () => {
        return (
            <Modal show={this.state.showRemoveLinkedSessionsModal} onClose={this._hideRemoveLinkedSessionsModal}>
                <h2 className="linked">Linked Sessions</h2>
                <p>The session you have selected is linked to other sessions on your schedule. Removing this session will remove all linked sessions.</p>
                <p>Would you like to remove the selected session?</p>
                <div className="row mt-4">
                    <div className="col-md-6"><button className="btn btn-primary btn-block" disabled={!this.state.selectedPresentationId} onClick={e => this._confirmRemoveLinkedSessions(e)}>Remove Sessions</button></div>
                    <div className="col-md-6"><button className="btn btn-secondary btn-block" disabled={!this.state.selectedPresentationId} onClick={this._hideRemoveLinkedSessionsModal}>Cancel</button></div>
                </div>

            </Modal>
        );
    }

    _removeSessionButtonText = presentation => {
        if (presentation.isWaitlist && !presentation.paid) {
            return "Remove from Waitlist";
        } else if (presentation.isNotify && presentation.isFull) {
            return "Remove Notify Me";
        } else {
            return "Remove";
        }
    }

    _addSessionButtonText = presentation => {
        if (presentation.isFull && presentation.hasWaitlist) {
            return "Add to Waitlist";
        } else if (presentation.isFull && !presentation.hasWaitlist) {
            return "Notify Me";
        } else {
            return "Add Session";
        }
    }

    render() {
        let { presentations } = this.props;
        if (Object.keys(presentations).length === 0) {
            return (
                <div className="row">
                    <div className="col-12">
                        <div className="info-box sessions-available">
                            <p>
                                The filter you have selected does not return any sessions for this day.
                            </p>
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div className="row">
                <div className="col-12">
                    <Accordion allowZeroExpanded accordion={"false"} className={"session-list" + (this.props.isLoading ? " loading" : "")}>
                        {Object.keys(presentations).map((date, index) => (
                            <AccordionItem key={date}>
                                <AccordionItemHeading>
                                    <AccordionItemButton>
                                        <div className="row session-header">
                                            <div className="session-date u-position-relative col-7 col-lg-7 pl-1 pl-lg-4">
                                                <div className="accordion__arrow ml-1 d-none d-lg-inline-block" role="presentation" />
                                                <span className="pl-3">
                                                    <Moment format="h:mm A">{date}</Moment>
                                                </span>
                                            </div>
                                            <div className="col-lg-1 d-none d-lg-inline-block">
                                                <span className="header-column">
                                                    CE Hrs
                                                </span>
                                            </div>
                                            <div className="col-lg-1 d-none d-lg-inline-block">
                                                <span className="header-column">
                                                    Fee
                                                </span>
                                            </div>
                                            <div className="col-5 col-lg-3 session-count pr-4">
                                                {presentations[date].length} Sessions
                                                <div className="accordion__arrow ml-3 mr-1 d-lg-none" role="presentation" />
                                            </div>
                                        </div>
                                    </AccordionItemButton>
                                </AccordionItemHeading>
                                <AccordionItemPanel>
                                    <div>
                                        {presentations[date].map((session, index) => (
                                            <Accordion allowZeroExpanded key={session.id} className="session-item pb-2">                                            
                                                <AccordionItem expanded={this.state.accordionExpanded[session.id]} key={session.id} uuid={session.id}>

                                                    {console.log("Expanded: " + this.state.accordionExpanded[session.id])}

                                                    <AccordionItemHeading>
                                                        <AccordionItemButton>
                                                            <div onClick={e => this._toggleDetails(session.id)} className="clickable">
                                                                <div className="row header">
                                                                    <div className="col-lg-7 pl pl-lg-4 pl-3">
                                                                        <div className="arrow right ml-1 d-none d-lg-inline-block mr-2" />
                                                                        <span className="text-bold d-none d-lg-inline-block">
                                                                            {session.titleShortName}
                                                                        </span>
                                                                        <div className="text-bold d-lg-none pl-0 pr-3 session-title">
                                                                            {session.titleShortName}
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-1 ce-hours d-none d-lg-flex">
                                                                        {session.contactHours}
                                                                    </div>
                                                                    <div className="col-md-1 fee d-none d-lg-flex pl-3">
                                                                        {session.presentationFee ? "$" + session.presentationFee.toFixed(2) : ""}
                                                                    </div>
                                                                    <div className="col-lg-3 d-none d-lg-flex justify-content-end">
                                                                        {(session.isRegistered || (session.isWaitlist && session.hasWaitlist && session.isFull && session.isRegistered) || (!session.hasWaitlist && session.isNotify && session.isFull)) ?
                                                                            <button className="btn btn-remove-session" onClick={e => this._removeSession(session.id, e)}>{this._removeSessionButtonText(session)}</button>
                                                                            :
                                                                            <button className="btn btn-add-session" onClick={e => this._addSession(session.id, e)}>{this._addSessionButtonText(session)}</button>
                                                                        }
                                                                    </div>
                                                                </div>
                                                                <div className="ml-3 pl-1 pl-lg-0 row presentation-time">
                                                                    <div className="col-md-6">
                                                                        <span>
                                                                            <Moment format="h:mm A">{session.startTime}</Moment> - <Moment format="h:mm A">{session.endTime}</Moment>
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                <div className="row mt-1 d-lg-none mb-1 ml-3 pl-1">
                                                                    <div className="col-12">
                                                                        {session.contactHours} CE Hours {session.presentationFee ? " | " : ""} <span className="fee">{session.presentationFee ? "$" + session.presentationFee.toFixed(2) + " Fee" : ""}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </AccordionItemButton>
                                                    </AccordionItemHeading>
                                                    <AccordionItemPanel>
                                                        <div className="row ml-4 pt-3">
                                                            <div className="col-md-9 pl-0 pl-lg-2 session-details">
                                                                <div className="row mb-1">
                                                                    <div className="col-lg-3 col-4">Date :</div>
                                                                    <div className="col-lg-9 col-8"><Moment format="dddd (M/D)">{session.presentationDate}</Moment></div>
                                                                </div>
                                                                <div className="row mb-1">
                                                                    <div className="col-lg-3 col-4">Time :</div>
                                                                    <div className="col-lg-9 col-8"><Moment format="h:mm A">{session.startTime}</Moment></div>
                                                                </div>
                                                                {session.levelDisplayText &&
                                                                    <div className="row mb-1">
                                                                        <div className="col-lg-3 col-4">Content Level :</div>
                                                                        <div className="col-lg-9 col-8">{session.levelDisplayText}</div>
                                                                    </div>
                                                                }
                                                                {session.speakerListing &&
                                                                    <div className="row mb-1 speakers d-lg-none">
                                                                        <div className="col-lg-3 col-4">Speaker(s) :</div>
                                                                        <div className="col-lg-9 col-8">
                                                                            {session.speakerListing}
                                                                        </div>
                                                                    </div>
                                                                }
                                                                <div className="row mb-1 d-none d-lg-flex">
                                                                    <div className="col-lg-3 col-4">CE Hours :</div>
                                                                    <div className="col-lg-9 col-8">{session.contactHours}</div>
                                                                </div>
                                                                {session.therapeuticAreas.length > 0 &&
                                                                    <div className="row mb-1 mt-1">
                                                                        <div className="col-lg-3 col-4 mt-1">Subjects :</div>
                                                                        <div className="col-lg-9 col-8">
                                                                            {session.therapeuticAreas.map((t, index) => (
                                                                                <span className="therapeutic-area" key={index}>{t.name}</span>
                                                                            ))}
                                                                        </div>
                                                                    </div>
                                                                }
                                                                <div className="row pl-0 pl-lg-3 mr-3 pt-3 pb-2">
                                                                    <div className="presentation-description" dangerouslySetInnerHTML={{ __html: session.description }} />
                                                                </div>
                                                            </div>
                                                            <div className="col-md-3 text-left d-none d-lg-block">
                                                                {session.speakerListing &&
                                                                    <div className="speakers">
                                                                        <div>Speaker(s):</div>
                                                                        <div>{session.speakerListing}</div>
                                                                    </div>
                                                                }
                                                            </div>
                                                        </div>
                                                    </AccordionItemPanel>
                                                    <div className="row d-lg-none mb-2">
                                                        <div className="col-12">
                                                            <button className="float-right mr-4 link-button" onClick={e => this._toggleDetails(session.id)}>                                                     
                                                               {this.state.accordionExpanded[session.id] === "true" ? "See Less Info" : "See More Info"}
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div className="row d-lg-none mt-3 mb-2">
                                                        <div className="col-10 col-centered">
                                                            {session.isRegistered ?
                                                                <button className="btn btn-remove-session" onClick={e => this._removeSession(session.id, e)}>{this._removeSessionButtonText(session)}</button>
                                                                :
                                                                <button className="btn btn-add-session" onClick={e => this._addSession(session.id, e)}>{this._addSessionButtonText(session)}</button>
                                                            }
                                                        </div>
                                                    </div>
                                                    {(!session.isFull && session.isNotify && !session.isRegistered) &&
                                                        <div className="notify-info-box">
                                                            <p>
                                                                <b>Good news! You showed interest in this previously full session and there are now seats available.</b>
                                                            </p>
                                                        </div>
                                                    }
                                                    {(session.isFull && session.isNotify && !session.isRegistered && session.isNew) &&
                                                        <div className="notify-info-box text-center">
                                                            <p><b>You must complete the checkout process to be added to the notification list</b>.&nbsp;&nbsp;You will be notified by email if this session becomes available.</p>
                                                        </div>
                                                    }
                                                    {(session.isFull && session.isNotify && !session.isRegistered && !session.isNew) &&
                                                        <div className="notify-info-box text-center">
                                                            <p><b>This session is currently full.</b>&nbsp;&nbsp;You will be notified by email if this session becomes available.</p>

                                                        </div>
                                                    }
                                                    {(session.isFull && session.hasWaitlist && !session.isNew && session.isWaitlist) &&
                                                        <div className="notify-info-box text-center">
                                                            <p><b>You are currently in the waitlist for this session</b>.&nbsp;&nbsp;You will be notified by email if this session becomes available.</p>
                                                        </div>
                                                    }
                                                    {(session.isFull && session.hasWaitlist && session.isNew && session.isWaitlist) &&
                                                        <div className="notify-info-box text-center">
                                                            <p><b>You must complete the checkout process to be added to the waitlist</b>.&nbsp;&nbsp;You will be notified by email if this session becomes available.</p>
                                                        </div>
                                                    }

                                                </AccordionItem>
                                            </Accordion>
                                        ))}
                                    </div>
                                </AccordionItemPanel>
                            </AccordionItem>
                        ))}
                    </Accordion>
                </div>
                {this._addLinkedPresentationsModal()}
                {this._removeLinkedPresentationsModal()}
                {this._addWaitlistModal()}
                {this._notifyMeModal()}
            </div>
        );
    }
}